@if (isShowProductDropdown) {
	<ea-dropdown-nav-item
		#dropdownContentNav
		[showArrow]="true"
		tooltipText="Other Services"
		faIconClass="th"
		[dropdownId]="constants.dropdownIds.otherServices"
	>
		<ng-template #dropdownContent>
			<ul class="other-services-menu">
				@for (product of productList; track product; let lastProduct = $last) {
					<li (keydown)="handleDropdownOnKeydown(lastProduct, false, false)">
						<ea-button-link
							id="{{ product.name }}Link"
							name="product"
							[isDisabled]="product.id === activeProduct"
							(onClick)="onSetActiveProduct(product.id)"
						>
							{{ product.name }}
						</ea-button-link>
					</li>
				}
				@for (pathway of pathwayList; track pathway; let lastPathway = $last) {
					<li (keydown)="handleDropdownOnKeydown(false, lastPathway, false)">
						<ea-button-link
							id="{{ pathway.name }}Link"
							name="pathway"
							[isDisabled]="pathway.id === activePathwayId"
							(onClick)="onSetActivePathway(pathway)"
						>
							{{ pathway.name }}
						</ea-button-link>
					</li>
				}
				@for (
					otherBenefit of consolidatedLoginBenefits;
					track otherBenefit;
					let lastOtherBenefit = $last
				) {
					<li
						(keydown)="handleDropdownOnKeydown(false, false, lastOtherBenefit)"
					>
						<a
							[href]="otherBenefit.benefitPageUrl"
							target="_blank"
							id="{{ otherBenefit.benefitName }}Link"
							>{{ otherBenefit.benefitName }}</a
						>
					</li>
				}
			</ul>
		</ng-template>
	</ea-dropdown-nav-item>
}
